import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { createInvoiceAmountAsync, deleteInvoiceAmountAsync, getAllInvoiceAmountsAsync, updateInvoiceAmountAsync } from '@application/features/invoices/invoiceThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { handleRolePermission } from '@infrastructure/helpers';
import VnButton from '@ui/components/VnButton';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import VnValidation from '@ui/components/VnValidation';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { useParams } from 'react-router-dom';
const AddInvoiceAmountForm = ({ onClose, updateCase, isDisabled, isInvoiceAmountTabBold }) => {
    const [isToogled, setIsToggled] = useState(true);
    const [amount, setAmount] = useState(null);
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const [stateQuantity, setQuanity] = useState(0);
    const [statePrice, setPrice] = useState(0);
    const [isInvoiceAmountDeletePopup, setisInvoiceAmountDeletePopup] = useState(false);
    const { InvoiceAmount } = useAppSelector((state) => state.invoice);
    const { setValue, handleSubmit, register, clearErrors, watch, control, formState: { errors } } = useForm({
        defaultValues: {}
    });
    const isAmountToggleButton = watch('isAmountHidden');
    useEffect(() => {
        setValue('description', InvoiceAmount?.description);
        setValue('quantity', InvoiceAmount?.quantity);
        setValue('price', InvoiceAmount?.price);
        setQuanity(InvoiceAmount?.quantity);
        setPrice(InvoiceAmount?.price);
        setValue('isAmountHidden', InvoiceAmount?.isAmountHidden);
    }, [InvoiceAmount]);
    const onCreateSubmit = (data) => {
        data.invoiceId = parseInt(id);
        if (!data.quantity) {
            data.quantity = null;
        }
        if (!data.price) {
            data.price = null;
        }
        dispatch(createInvoiceAmountAsync(data))
            .unwrap()
            .then(() => {
            onClose();
            if (id) {
                dispatch(getAllInvoiceAmountsAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    if (isInvoiceAmountTabBold && res.length > 0) {
                        isInvoiceAmountTabBold(true);
                    }
                    else {
                        isInvoiceAmountTabBold && isInvoiceAmountTabBold(false);
                    }
                });
            }
        });
    };
    const onUpdateSubmit = (data) => {
        data.invoiceId = parseInt(id);
        data.id = InvoiceAmount?.id;
        data.isAmountHidden = isAmountToggleButton;
        if (!data.quantity) {
            data.quantity = null;
        }
        if (!data.price) {
            data.price = null;
        }
        if (!isDisabled) {
            dispatch(updateInvoiceAmountAsync(data))
                .unwrap()
                .then(() => {
                onClose();
                if (id) {
                    dispatch(getAllInvoiceAmountsAsync(parseInt(id)));
                }
            });
        }
    };
    useEffect(() => {
        calculateStateAmount();
        if (stateQuantity) {
            clearErrors('quantity');
        }
        if (statePrice) {
            clearErrors('price');
        }
    }, [stateQuantity, statePrice]);
    const calculateStateAmount = () => {
        if (stateQuantity !== undefined && statePrice !== undefined && !Number.isNaN(stateQuantity) && !Number.isNaN(statePrice)) {
            const calculatedAmount = Math.round(stateQuantity * statePrice * 100) / 100;
            setAmount(calculatedAmount);
            setValue('amount', calculatedAmount);
        }
        if (Number.isNaN(stateQuantity) && Number.isNaN(statePrice)) {
            setAmount(0);
            setValue('amount', 0);
        }
    };
    const handleChange = (e, fieldName) => {
        if (e.key !== 'Backspace') {
            if (e.target.value.includes('.')) {
                const [integerPart, decimalPart] = e.target.value.split('.');
                if (decimalPart && decimalPart.length > 2) {
                    const truncatedValue = parseFloat(`${integerPart}.${decimalPart.slice(0, 2)}`);
                    setValue(fieldName, truncatedValue);
                    e.preventDefault();
                }
            }
        }
    };
    const deleteQuotationAmount = () => {
        setisInvoiceAmountDeletePopup(true);
    };
    const onCancelDeleteClicked = () => {
        setisInvoiceAmountDeletePopup(false);
    };
    const onDeleteClicked = () => {
        dispatch(deleteInvoiceAmountAsync(InvoiceAmount?.id))
            .unwrap()
            .then(() => {
            onClose();
            setisInvoiceAmountDeletePopup(false);
            dispatch(getAllInvoiceAmountsAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                if (isInvoiceAmountTabBold && res.length > 0) {
                    isInvoiceAmountTabBold(true);
                }
                else {
                    isInvoiceAmountTabBold && isInvoiceAmountTabBold(false);
                }
            });
        });
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: 'mt-4', children: [_jsxs("form", { onSubmit: updateCase ? handleSubmit(onUpdateSubmit) : handleSubmit(onCreateSubmit), children: [_jsx("div", { className: 'row', children: _jsxs("div", { className: 'col-sm-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Omschrijving" }), _jsx("span", { className: 'vn-AsterikMark', children: "*" }), _jsx("textarea", { className: 'vn-Input', rows: 8, ...register('description', {
                                            required: 'Dit veld is verplicht'
                                        }) }), _jsx(VnValidation, { fieldError: errors.description })] }) }), _jsx("div", { className: 'row mt-3', children: _jsx("div", { className: 'col-5', children: _jsxs("span", { className: 'Vn-form-SpeedSpan', children: [_jsxs("label", { className: 'Vn-toggle-button-switch', children: [_jsx("input", { type: 'checkbox', ...register('isAmountHidden'), defaultChecked: InvoiceAmount?.isAmountHidden }), _jsx("span", { className: 'Vn-toggle-button-slider Vn-toggle-button-round' })] }), _jsx("span", { className: 'Vn-form-text ml-2', children: "Tonen bedrag" })] }) }) }), isAmountToggleButton && (_jsxs("div", { className: 'row mt-3', children: [_jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Aantal" }), _jsx("span", { className: 'vn-AsterikMark', children: "*" }), _jsx(Controller, { name: 'quantity', control: control, rules: { required: 'Dit veld is verplicht' }, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', value: value, onValueChange: ({ value }) => {
                                                    const inputValue = value;
                                                    if (inputValue === '') {
                                                        onChange(null);
                                                    }
                                                    else {
                                                        onChange(inputValue);
                                                        setQuanity(parseFloat(inputValue));
                                                    }
                                                }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) }), errors.quantity && _jsx("div", { className: 'validation-error', children: errors.quantity.message })] }), _jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Prijs" }), _jsx("span", { className: 'vn-AsterikMark', children: "*" }), _jsx(Controller, { name: 'price', control: control, rules: { required: 'Dit veld is verplicht' }, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', value: value, onValueChange: ({ value }) => {
                                                    const inputValue = value;
                                                    if (inputValue === '') {
                                                        onChange(null);
                                                    }
                                                    else {
                                                        onChange(inputValue);
                                                        setPrice(parseFloat(value));
                                                    }
                                                }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false })) }), errors.price && _jsx("div", { className: 'validation-error', children: errors.price.message })] })] })), isAmountToggleButton && (_jsxs("div", { className: 'row mt-3', children: [_jsx("div", { className: 'col-sm-6' }), _jsxs("div", { className: 'col-sm-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Bedrag" }), _jsx(Controller, { name: 'amount', control: control, rules: { required: 'Dit veld is verplicht' }, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', value: value, onValueChange: ({ value }) => {
                                                    const inputValue = value;
                                                    if (inputValue === '') {
                                                        onChange(null);
                                                    }
                                                    else {
                                                        onChange(inputValue);
                                                    }
                                                }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, readOnly: true })) }), errors.amount && _jsx("div", { className: 'validation-error', children: errors.amount.message })] })] })), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', isDisabled: isDisabled, children: "Annuleren" }), updateCase ? (_jsxs(_Fragment, { children: [_jsx(VnButton, { style: { marginLeft: '8px' }, customClassName: 'vn-popup-delete-button', mode: 'danger', type: 'button', onClick: () => deleteQuotationAmount(), isDisabled: !handleRolePermission(Permission.FACTUREN, PermissionType.Delete) || isDisabled, children: "Verwijderen" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.FACTUREN, PermissionType.Update) || isDisabled, children: "Opslaan" })] })) : (_jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.FACTUREN, PermissionType.Create) || isDisabled, children: "Opslaan" }))] }) })] }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isInvoiceAmountDeletePopup })] }) }));
};
export default AddInvoiceAmountForm;
